<template>
  <d-container fluid>
    <d-row>
      <d-col class="main-content mb-4 p-0" tag="main" lg="12" md="12" sm="12">
        <div id="scroll-detector"></div>
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'worker-view',
  data() {
    return {
      scrollObserver: null,
      scrollDetector: null
    };
  },
  mounted () {
    if ('IntersectionObserver' in window) {
      this.scrollDetector = document.querySelector('#scroll-detector');
      this.scrollObserver = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio === 0) {
            document.body.classList.add('is-scrolled');
          }
          if (e.intersectionRatio === 1) {
            document.body.classList.remove('is-scrolled');
          }
        },
        {
          threshold: [0, 1]
        }
      );
      this.scrollObserver.observe(this.scrollDetector);
    }
  },
  beforeDestroy () {
    if ('IntersectionObserver' in window && this.scrollObserver) {
      this.scrollObserver.unobserve(this.scrollDetector);
    }
  }
};
</script>

<style lang="scss" scoped>
#scroll-detector {
  background: transparent;
  height: 1px;
  width: 100%;
}
</style>
